<template>
  <div class="wapper">
    <div class="border-wapper"/>
    <div class="header">
      <div class="headerContent">{{ name }}</div>
      <slot name="back"></slot>
    </div>
    <div class="main">
      <slot name="content"></slot>
    </div>
    <div class="bottom-left" />
    <div class="bottom-right" />
  </div>
</template>

<script>
export default {
  name: 'resourceBox',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="less">
.wapper {
  width: 100%;
  height: 100%;
  background: #ffffff;
  background: linear-gradient(180deg, rgba(14, 40, 73, 0.2) 0%, rgba(32, 73, 130, 0) 100%);
  /* 合并左右边框样式，避免重复 */
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgb(18, 58, 29), rgb(58, 161, 168), rgba(18, 58, 29)) 1;
  position: relative;
  .border-wapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-left: 1px solid;
    border-right: 1px solid;
    border-image: linear-gradient(
        -180deg,
        rgba(0, 0, 0, 1) 0%,
        rgb(18, 58, 29,0.5) 40%,
        rgb(18, 58, 29,1) 99%
    )
    2 2 2 2;
    background: linear-gradient(180deg, rgba(14, 74, 50, 0.2) 0%, rgba(15, 66, 43, 0) 100%);
  }
  .header {
    height: 40px;
    width: 100%;
    background: url('~@/assets/recycling/chinaMap/resourceBoxHeader.svg') no-repeat;
    background-size: contain;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .headerContent {
      height: 100%;
      font-size: 18px;
      display: flex;
      align-items: center;
      padding-left: 45px;
      font-weight: 900;
      color: #ffffff;
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 40px);
  }
  .bottom-left {
    width: 8px;
    height: 8px;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #00eeff;
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%);
  }
  .bottom-right {
    width: 8px;
    height: 8px;
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: #00eeff;
    clip-path: polygon(100% 100%, 0% 100%, 100% 0%);
  }
}
</style>
